/**
 * Normalizes `/permission/user` API payloads into the grouped module map
 * consumed by {@link PermissionService.applyGroupedPermissions}.
 */
export function extractGroupedPermissionsPayload(
  res: unknown,
): Record<string, unknown> | null {
  if (!res || typeof res !== 'object') {
    return null;
  }
  const body = res as Record<string, unknown>;
  const statusOk =
    body['status'] === true ||
    (typeof body['statusCode'] === 'number' &&
      body['statusCode'] < 400 &&
      body['status'] !== false);
  if (!statusOk) {
    return null;
  }
  const data = body['data'];
  if (!data || typeof data !== 'object') {
    return null;
  }
  const record = data as Record<string, unknown>;
  const nested = record['result'];
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return nested as Record<string, unknown>;
  }
  return record;
}
